
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Check and update dark mode status whenever theme changes
  useEffect(() => {
    const checkTheme = () => {
      const isDark = document.documentElement.classList.contains('dark');
      setIsDarkMode(isDark);
    };

    // Initial check
    checkTheme();
    
    // Listen for theme change events
    const handleThemeChange = (e: CustomEvent) => {
      setIsDarkMode(e.detail.isDark);
    };
    
    window.addEventListener('themechange', handleThemeChange as EventListener);
    
    // Create a mutation observer to watch for class changes on the html element as a fallback
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          checkTheme();
        }
      });
    });
    
    // Start observing
    observer.observe(document.documentElement, { attributes: true });
    
    // Cleanup
    return () => {
      window.removeEventListener('themechange', handleThemeChange as EventListener);
      observer.disconnect();
    };
  }, []);

  return (
    <Link to="/" className="flex items-center">
      {isDarkMode ? (
        <img 
          src="/uploads/jspark-logo-dark.png" 
          alt="JSPARK Prime" 
          className="h-10 transition-opacity duration-300"
        />
      ) : (
        <img 
          src="/uploads/jspark-logo-light.png" 
          alt="JSPARK Prime" 
          className="h-10 transition-opacity duration-300"
        />
      )}
    </Link>
  );
};

export default Logo;
